/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewnoteburst3Inputs */

const en_sharereviewnoteburst3 = /** @type {(inputs: Sharereviewnoteburst3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many visits in a short time`)
};

const de_sharereviewnoteburst3 = /** @type {(inputs: Sharereviewnoteburst3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viele Besuche in kurzer Zeit`)
};

/**
* | output |
* | --- |
* | "Many visits in a short time" |
*
* @param {Sharereviewnoteburst3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewnoteburst3 = /** @type {((inputs?: Sharereviewnoteburst3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewnoteburst3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewnoteburst3(inputs)
	return de_sharereviewnoteburst3(inputs)
});
export { sharereviewnoteburst3 as "shareReviewNoteBurst" }